import React, { useState } from 'react'
import styled from 'styled-components'
import theme from '../../styles/theme'
import { useAuth } from './AuthProvider'

const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: white;
  padding: 2rem;
`

const LoginCard = styled.div`
  background: ${theme.color.background.light};
  border-radius: 8px;
  padding: 3rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  text-align: center;
  max-width: 400px;
  width: 100%;
`

const Logo = styled.img`
  max-height: 120px;
  max-width: 300px;
  height: auto;
  width: auto;
  object-fit: contain;
  margin-bottom: 2rem;
`

const Title = styled.h1`
  color: ${theme.color.text.base};
  font-size: 2rem;
  margin-bottom: 1rem;
  font-weight: 600;
`

const Subtitle = styled.p`
  color: ${theme.color.text.grey};
  font-size: 1rem;
  margin-bottom: 2rem;
  line-height: 1.5;
`

const LoginButton = styled.button`
  background: ${theme.color.accent.primary};
  color: white;
  border: none;
  padding: 1rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
  transition: all 0.2s ease;

  &:hover {
    background: #b8002e;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: #666;
    cursor: not-allowed;
    transform: none;
  }
`

const ErrorMessage = styled.div`
  background: rgba(255, 68, 68, 0.1);
  color: #ff6b6b;
  padding: 1rem;
  border-radius: 4px;
  border: 1px solid rgba(255, 68, 68, 0.3);
  margin-bottom: 1rem;
`

const LoginPage: React.FC = () => {
  const { login } = useAuth()
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const handleSignIn = async () => {
    setError('')
    setIsLoading(true)
    try {
      await login()
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Sign in failed')
      setIsLoading(false)
    }
  }

  return (
    <LoginContainer>
      <LoginCard>
        <Logo src="/portal-logo.png" alt="Barry's International Admin Portal" />
        <Title>International Admin Portal</Title>
        <Subtitle>Sign in with your Barry's Okta account to continue.</Subtitle>

        {error && <ErrorMessage>{error}</ErrorMessage>}

        <LoginButton onClick={handleSignIn} disabled={isLoading}>
          {isLoading ? 'Redirecting…' : 'Sign in with Okta'}
        </LoginButton>
      </LoginCard>
    </LoginContainer>
  )
}

export default LoginPage
